module.exports = __webpack_public_path__ + "img/edge.7f4dae0b.svg";